export default __webpack_public_path__ + "static/media/mobile-7.3da0a9f9.png";